/* SolutionsManagement.js */

"use strict";
const Registrations = require("../../RegistrationNamespaces");

module.exports = {
    name: "solutions_management",
    label: "Solutions Manager",
    disabled: false,
    app: "GameConsole",
    order: 12, // Depricated -- Newer solution uses order from index.js
    section: "GameCenter",
    license: ["GLUWARE"],
    accessPerm: ["solutionManagementAccess"],
    pageTitle: "Gluware Solutions Management",
    helpLink: "Config%20Modeling/Solutions-Management-quick-reference.htm",
    lmrbNamespaces: [Registrations.PACKAGE_EXPLORER_LMRB],
    editorNamespaces: [Registrations.PACKAGE_EDITOR],
    navIcon: "solutionmanager.solution",
    iconName: "branding.solutionsManagement",
    navOptions: {
        available: {
            name: "Available Packages",
            options: {
                exp: "available",
            },
            type: "exp",
        },
        installed: {
            name: "Installed Packages",
            options: {
                exp: "installed",
            },
            type: "exp",
        },
    },
};
